import { render, staticRenderFns } from "./UpdaterStatusBadges.vue?vue&type=template&id=12358dde&scoped=true&"
import script from "./UpdaterStatusBadges.vue?vue&type=script&lang=js&"
export * from "./UpdaterStatusBadges.vue?vue&type=script&lang=js&"
import style0 from "./UpdaterStatusBadges.vue?vue&type=style&index=0&id=12358dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12358dde",
  null
  
)

export default component.exports